
// export const logout = ( state ) => {
// }

export const setOutputdetailResume = (state, outputdetailResume) => {
    state.outputdetailResume = outputdetailResume
}

export const saveNewOutputdetailsResume = (state, outputdetailResume) => {
    // state.outputdetailResumes.unshift(outputdetailResume)
    state.createdData = outputdetailResume;
}

export const saveUpdatedOutputdetailResume = (state, outputdetailResume) => {
    // state.outputdetailResumes.unshift(outputdetailResume)
    state.updatedData = outputdetailResume;
}

export const setOutputdetailResumeIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setOutputdetailResumeIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setOutputdetailResumeIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setOutputdetailResumeIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setDeleteOutputdetailResume = (state, outputdetailResume) => {
    state.deletedData = outputdetailResume
}